'use strict';

angular.module('app.updateDuplicationFactors', [])
	.controller('updateDuplicationFactorsCtrl', ['$scope', '$modalInstance', '$modal', 'updateDuplicationFactorsService',
		function ($scope, $modalInstance, $modal, updateDuplicationFactorsService) {
		    
		    $scope.confirmUpdateDuplicationFactors = function () {
		        $scope.selectedPeriod = "";
		        angular.forEach($scope.period, function (item) {
		            if (item.ticked == true) {
		                $scope.selectedPeriod = item;
		            }
		        })

		        var params = {
		            data: $scope.duplicationFactors,
		            month: $scope.duplicationFactors[0].month
		        }

		        updateDuplicationFactorsService.updateDuplicationFactors(params, true)
		        	.then(function(response) {
		        		$modalInstance.close(function () {
			                $log.info('Close Modal now');
			            })
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
		        	})
		    }
		    $scope.closeModal = function(){
		        $modalInstance.close();    
		    }
}])